import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataTableEvent } from '../../components/data-table/data-table.component';

@Component({
    selector: 'app-application-variant',
    templateUrl: './application-variant.component.html',
    styleUrls: ['./application-variant.component.scss'],
    standalone: false
})
export class ApplicationVariantComponent implements OnInit {

  public variants = [
    {variant : 'standard'},
    {variant : 'accenture'},
    {variant : 'develop-accenture'},
    {variant : 'develop-uri-tourismus'},
    {variant : 'develop-ibexfusion5-backend'},
    {variant : 'develop-seniorenzentrum-engelhof'},
    {variant : 'feature-content-caching'},
    {variant : 'develop-standard'},
    {variant : 'develop-messenger'},
    {variant : 'develop-setup-screen'},
    {variant : 'master-standard'},
    {variant : 'ibexPlayer'},
    {variant : 'autogrill-muensingen'},
    {variant : 'uri-tourismus'},
    {variant : 'engelhof'},
    {variant : 'gemeinde-lachen'},
    {variant : 'altersheim-frohmatt'},
    {variant : 'showroom'},
    {variant : 'autogrill-air'},
    {variant : 'altersheim-berneck'},
    {variant : 'aegerisee'}
  ];
  public params = this.variants;

  public columns = [{ prop: 'variant' }];

  constructor(private router: Router) {
  }

  ngOnInit() {
  }

  public onDetail(event: DataTableEvent) {
    this.router.navigate(['application-versions', event.row.variant]);
  }

}
